(() => {
  const roots = document.querySelectorAll('[data-japotyle-photo-root]');

  roots.forEach((root) => {
    const form = root.querySelector('.japotyle-product-form');
    const option = root.querySelector('[data-photo-option]');
    const checkbox = root.querySelector('[data-photo-checkbox]');
    const submitButton = form?.querySelector('[name="add"]');
    const price = root.querySelector('[data-japotyle-price]');
    const sku = root.querySelector('[data-japotyle-current-sku]');
    const stock = root.querySelector('[data-japotyle-current-stock]');
    const error = root.querySelector('[data-photo-error]');
    const optionPrice = root.querySelector('[data-photo-total-price]');
    const tooltipPrice = root.querySelector('[data-photo-tooltip-price]');
    const calculation = root.querySelector('[data-photo-calculation]');

    if (!form || !submitButton) return;

    const selectedVariant = () => form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
    const photoCountFor = (selected) => {
      const parsed = Number.parseInt(selected?.dataset.photoApprovalCount || '1', 10);
      return Number.isFinite(parsed) ? Math.max(parsed, 0) : 1;
    };
    const photoSkusFor = (selected) => {
      try {
        const parsed = JSON.parse(selected?.dataset.photoApprovalSkus || '[]');
        return Array.isArray(parsed) ? parsed.filter(Boolean).map(String) : [];
      } catch (_error) {
        return [];
      }
    };
    const unitPriceCents = Math.max(Number.parseInt(root.dataset.servicePriceCents || '500', 10) || 500, 0);
    const currency = window.Shopify?.currency?.active || 'USD';
    const locale = document.documentElement.lang || 'en';
    const money = (cents) => new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);

    const renderVariant = () => {
      const selected = selectedVariant();
      if (!selected) return;

      const isUsed = selected.dataset.isUsed === 'true';
      const isAvailable = selected.dataset.available === 'true';
      const photoCount = photoCountFor(selected);
      const canRequestPhotos = isUsed && isAvailable && photoCount > 0 && Boolean(root.dataset.serviceVariantId);
      const totalPrice = money(unitPriceCents * photoCount);

      if (optionPrice) optionPrice.textContent = '+' + totalPrice;
      if (tooltipPrice) tooltipPrice.textContent = '+' + totalPrice;
      if (calculation) {
        calculation.hidden = photoCount <= 1;
        calculation.textContent = photoCount + ' × ' + money(unitPriceCents) + ' = ' + totalPrice;
      }

      if (option && checkbox) {
        option.hidden = !canRequestPhotos;
        checkbox.disabled = !canRequestPhotos;
        if (!canRequestPhotos) checkbox.checked = false;
      }

      if (price) {
        const comparePrice = selected.dataset.comparePrice;
        price.innerHTML = `<span class="japotyle-price">${selected.dataset.price || ''}</span>${comparePrice ? `<span class="japotyle-compare-price">${comparePrice}</span>` : ''}`;
      }
      if (sku) sku.textContent = selected.dataset.sku || '';
      if (stock) stock.textContent = isAvailable ? root.dataset.stockLabel : root.dataset.unavailableLabel;

      submitButton.disabled = !isAvailable;
      submitButton.textContent = isAvailable ? root.dataset.addLabel : root.dataset.unavailableLabel;
      if (error) error.hidden = true;
    };

    form.addEventListener('change', (event) => {
      if (event.target.matches('input[name="id"]')) renderVariant();
    });

    form.addEventListener('submit', async (event) => {
      if (!checkbox?.checked) return;

      event.preventDefault();
      const selected = selectedVariant();
      if (!selected || selected.dataset.isUsed !== 'true' || selected.dataset.available !== 'true') {
        renderVariant();
        return;
      }

      const originalLabel = submitButton.textContent;
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.textContent = root.dataset.addingLabel;
      if (error) error.hidden = true;

      const photoCount = photoCountFor(selected);
      const photoSkus = photoSkusFor(selected);
      if (photoCount <= 0) {
        renderVariant();
        return;
      }
      const linkedItem = [root.dataset.productTitle, selected.dataset.sku].filter(Boolean).join(' · ');
      const bundleId = window.crypto?.randomUUID?.() || `photo-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      const productProperties = {
        [root.dataset.photoProperty]: root.dataset.photoPropertyValue + ' (' + photoCount + ' pre-owned item' + (photoCount === 1 ? '' : 's') + ')',
        'Photo items': String(photoCount),
        ...(photoSkus.length ? { 'Photo item SKUs': photoSkus.join(', ') } : {}),
        _photo_approval_required: 'true',
        _photo_service_sku: root.dataset.serviceSku,
        _photo_bundle_id: bundleId
      };
      const serviceProperties = {
        [root.dataset.forItemProperty]: linkedItem,
        SKU: selected.dataset.sku || '',
        'Photo items': String(photoCount),
        ...(photoSkus.length ? { 'Photo item SKUs': photoSkus.join(', ') } : {}),
        _photo_approval_service: 'true',
        _linked_variant_id: selected.value,
        _linked_sku: selected.dataset.sku || '',
        _photo_bundle_id: bundleId
      };

      try {
        const postItems = async (items) => {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items })
          });
          const payload = await response.json().catch(() => ({}));
          if (!response.ok) {
            throw new Error(payload.description || root.dataset.errorLabel);
          }
          return payload;
        };

        await postItems([
          { id: Number(selected.value), quantity: 1, properties: productProperties },
          {
            id: Number(root.dataset.serviceVariantId),
            quantity: photoCount,
            parent_id: Number(selected.value),
            properties: serviceProperties
          }
        ]);

        window.location.assign(root.dataset.cartUrl);
      } catch (requestError) {
        if (error) {
          error.textContent = requestError.message || root.dataset.errorLabel;
          error.hidden = false;
        }
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
        submitButton.textContent = originalLabel;
      }
    });

    renderVariant();
  });
})();
